import { render, staticRenderFns } from "./PlanEscritorio.vue?vue&type=template&id=3fc87dc9&scoped=true&"
import script from "./PlanEscritorio.vue?vue&type=script&lang=js&"
export * from "./PlanEscritorio.vue?vue&type=script&lang=js&"
import style0 from "./PlanEscritorio.vue?vue&type=style&index=0&id=3fc87dc9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc87dc9",
  null
  
)

export default component.exports